var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-[99px] pt-60 grid grid-cols-1 gap-80 lg:gap-120" },
    [
      _vm._l(_vm.articles.slice(0, 3), function(article, index) {
        return _c(
          "div",
          {
            key: article.id,
            staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-32"
          },
          [
            _c(
              "div",
              {
                staticClass: "flex justify-center flex-col",
                class: {
                  "order-2 lg:pl-32": index % 2 === 0,
                  "order-2 lg:order-1 lg:pr-32": index % 2 !== 0
                }
              },
              [
                _c(
                  "h5",
                  { staticClass: "uppercase text-red mb-16 font-extraBold" },
                  [
                    _vm._v(
                      _vm._s(_vm._f("moment")(article.date, "DD MMM YYYY"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass:
                      "text-32 text-black uppercase font-extraBold mb-24"
                  },
                  [_vm._v(_vm._s(article.title.rendered))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-gray-800 mb-24" }, [
                  _vm._v(_vm._s(article.acf.intro))
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "bg-black text-white rounded-8 font-extraBold py-[20px] px-[22px] uppercase text-18 border border-black hover:bg-none transition-colors hover:text-black inline-block mr-auto",
                    attrs: { href: article.link }
                  },
                  [_vm._v("Lees meer")]
                )
              ]
            ),
            _vm._v(" "),
            article.acf.image
              ? _c("img", {
                  staticClass:
                    "h-[360px] lg:h-[485px] object-cover w-full lazyload",
                  class: {
                    "order-1": index % 2 === 0,
                    "order-1 lg:order-2": index % 2 !== 0
                  },
                  attrs: { "data-src": article.acf.image.url }
                })
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-32" },
        _vm._l(_vm.articles.slice(3, _vm.articles.length), function(article) {
          return _c("blog-card", {
            key: article.id,
            attrs: { article: article, theme: "light" }
          })
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }